export default function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-interpolate/src/quantize.js
// module id = LiZX
// module chunks = 0